// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file message_rule.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file message_rule.proto.
 */
export const file_message_rule: GenFile = /*@__PURE__*/
  fileDesc("ChJtZXNzYWdlX3J1bGUucHJvdG8SC2dycGMuYXBpLnYxItQCCg9NZXNzYWdlVGVtcGxhdGUSCgoCaWQYASABKAMSEgoKYWNjb3VudF9pZBgCIAEoAxIXCg9tZXNzYWdlX3R5cGVfaWQYAyABKAMSFQoNZXZlbnRfdHlwZV9pZBgEIAEoAxIRCglsYXlvdXRfaWQYBSABKAMSEwoLY2FtcGFpZ25faWQYBiABKAMSEgoKc2VydmljZV9pZBgHIAEoAxIOCgZ0YWJfaWQYCCABKAMSDgoGbG9jYWxlGAkgASgJEg8KB3N1YmplY3QYCiABKAkSDAoEYm9keRgLIAEoCRISCgppc19kZWxldGVkGAwgASgIEhIKCmlzX2RlZmF1bHQYDSABKAgSFgoOaXNfZXhhY3RfbWF0Y2gYDiABKAgSFgoOZW5hYmxlZF9sb2NhbGUYDyABKAkSEAoIcHJpb3JpdHkYECABKAMSDAoEcmFuaxgRIAEoAyKSAwoLTWVzc2FnZVJ1bGUSCgoCaWQYASABKAMSEgoKYWNjb3VudF9pZBgCIAEoAxIXCg9tZXNzYWdlX3R5cGVfaWQYAyABKAMSFQoNZXZlbnRfdHlwZV9pZBgEIAEoAxITCgtjYW1wYWlnbl9pZBgFIAEoAxISCgpzZXJ2aWNlX2lkGAYgASgDEg4KBnRhYl9pZBgHIAEoAxIQCghzZW5kX2JjYxgIIAEoCBIXCg9zZW5kX2RheXNfYWZ0ZXIYCSABKAUSHAoUc2VuZF9kYXlzX2luX2FkdmFuY2UYCiABKAUSHQoVc2VuZF9hdF9zcGVjaWZpY190aW1lGAsgASgJEhMKC2lzX2luYWN0aXZlGAwgASgIEhIKCmlzX2RlbGV0ZWQYDSABKAgSLwoJdGVtcGxhdGVzGA4gAygLMhwuZ3JwYy5hcGkudjEuTWVzc2FnZVRlbXBsYXRlEjgKEm9ic29sZXRlX3RlbXBsYXRlcxgPIAMoCzIcLmdycGMuYXBpLnYxLk1lc3NhZ2VUZW1wbGF0ZUIGWgQuO3BiYgZwcm90bzM");

/**
 * @generated from message grpc.api.v1.MessageTemplate
 */
export type MessageTemplate = Message<"grpc.api.v1.MessageTemplate"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: int64 account_id = 2;
   */
  accountId: bigint;

  /**
   * @generated from field: int64 message_type_id = 3;
   */
  messageTypeId: bigint;

  /**
   * @generated from field: int64 event_type_id = 4;
   */
  eventTypeId: bigint;

  /**
   * @generated from field: int64 layout_id = 5;
   */
  layoutId: bigint;

  /**
   * @generated from field: int64 campaign_id = 6;
   */
  campaignId: bigint;

  /**
   * @generated from field: int64 service_id = 7;
   */
  serviceId: bigint;

  /**
   * @generated from field: int64 tab_id = 8;
   */
  tabId: bigint;

  /**
   * @generated from field: string locale = 9;
   */
  locale: string;

  /**
   * @generated from field: string subject = 10;
   */
  subject: string;

  /**
   * @generated from field: string body = 11;
   */
  body: string;

  /**
   * @generated from field: bool is_deleted = 12;
   */
  isDeleted: boolean;

  /**
   * @generated from field: bool is_default = 13;
   */
  isDefault: boolean;

  /**
   * @generated from field: bool is_exact_match = 14;
   */
  isExactMatch: boolean;

  /**
   * @generated from field: string enabled_locale = 15;
   */
  enabledLocale: string;

  /**
   * @generated from field: int64 priority = 16;
   */
  priority: bigint;

  /**
   * @generated from field: int64 rank = 17;
   */
  rank: bigint;
};

/**
 * Describes the message grpc.api.v1.MessageTemplate.
 * Use `create(MessageTemplateSchema)` to create a new message.
 */
export const MessageTemplateSchema: GenMessage<MessageTemplate> = /*@__PURE__*/
  messageDesc(file_message_rule, 0);

/**
 * @generated from message grpc.api.v1.MessageRule
 */
export type MessageRule = Message<"grpc.api.v1.MessageRule"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: int64 account_id = 2;
   */
  accountId: bigint;

  /**
   * @generated from field: int64 message_type_id = 3;
   */
  messageTypeId: bigint;

  /**
   * @generated from field: int64 event_type_id = 4;
   */
  eventTypeId: bigint;

  /**
   * @generated from field: int64 campaign_id = 5;
   */
  campaignId: bigint;

  /**
   * @generated from field: int64 service_id = 6;
   */
  serviceId: bigint;

  /**
   * @generated from field: int64 tab_id = 7;
   */
  tabId: bigint;

  /**
   * @generated from field: bool send_bcc = 8;
   */
  sendBcc: boolean;

  /**
   * @generated from field: int32 send_days_after = 9;
   */
  sendDaysAfter: number;

  /**
   * @generated from field: int32 send_days_in_advance = 10;
   */
  sendDaysInAdvance: number;

  /**
   * @generated from field: string send_at_specific_time = 11;
   */
  sendAtSpecificTime: string;

  /**
   * @generated from field: bool is_inactive = 12;
   */
  isInactive: boolean;

  /**
   * @generated from field: bool is_deleted = 13;
   */
  isDeleted: boolean;

  /**
   * @generated from field: repeated grpc.api.v1.MessageTemplate templates = 14;
   */
  templates: MessageTemplate[];

  /**
   * @generated from field: repeated grpc.api.v1.MessageTemplate obsolete_templates = 15;
   */
  obsoleteTemplates: MessageTemplate[];
};

/**
 * Describes the message grpc.api.v1.MessageRule.
 * Use `create(MessageRuleSchema)` to create a new message.
 */
export const MessageRuleSchema: GenMessage<MessageRule> = /*@__PURE__*/
  messageDesc(file_message_rule, 1);

